import fetch from 'node-fetch';
import { toastr } from 'react-redux-toastr';

// An empty input must clear the column, so send null instead of '' which GraphQL rejects for Int/Float
const toNumberOrNull = (value) => (value === '' || value === null || value === undefined ? null : Number(value));

export default async function submit(values, dispatch) {
    const mutation = `
        mutation updateServiceFee(
            $id: Int,
            $feeType: String,
            $bookingFee: Int,
            $shopFee: Int,
            $driverFee: Int,
            $deliveryFee: Float,
            $dropFee: Float,
            $distanceFee: Float,
            $normalDistanceLimitKm: Int,
            $extraDistanceFee: Float,
            $bookingFeeDriverShare: Float,
            $bookingFeeCompanyShare: Float
        ) {
            updateServiceFee(
                id: $id,
                feeType: $feeType
                bookingFee: $bookingFee,
                shopFee: $shopFee,
                driverFee: $driverFee,
                deliveryFee: $deliveryFee,
                dropFee: $dropFee,
                distanceFee: $distanceFee,
                normalDistanceLimitKm: $normalDistanceLimitKm,
                extraDistanceFee: $extraDistanceFee,
                bookingFeeDriverShare: $bookingFeeDriverShare,
                bookingFeeCompanyShare: $bookingFeeCompanyShare
            ) {
                status
                errorMessage
            }
        }
    `;

    const response = await fetch('/graphql', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: mutation,
            variables: {
                id: values.id,
                feeType: values.feeType,
                bookingFee: values.bookingFee,
                shopFee: values.shopFee,
                driverFee: values.driverFee,
                deliveryFee: values.deliveryFee,
                dropFee: values.dropFee,
                distanceFee: values.distanceFee,
                normalDistanceLimitKm: toNumberOrNull(values.normalDistanceLimitKm),
                extraDistanceFee: toNumberOrNull(values.extraDistanceFee),
                bookingFeeDriverShare: values.bookingFeeDriverShare / 100,
                bookingFeeCompanyShare: values.bookingFeeCompanyShare / 100
            }
        }),
        credentials: 'include'
    });

    const { data } = await response.json();

    if(data && data.updateServiceFee && data.updateServiceFee.status === 200) {
        toastr.success("Success", "Service Fee Updated!")
    } else {
        toastr.error("Failed", "Update Service Fee failed")
    }
}